import { call, put, takeEvery } from "redux-saga/effects"
import { callApi } from "sagas/Api"
import { GET_LOCALE_AGREEMENT, storeLocaleAgreement } from "actions"
import { getLocaleAgreement } from "apis/LocaleAgreement"
import { handlingGetApiError } from "./CommonErrorHandling"

export function* handleGetLocaleAgreement() {
  yield takeEvery(GET_LOCALE_AGREEMENT, execGetLocaleAgreement)
}

export function* execGetLocaleAgreement() {
  const { payload, error } = yield call(callApi, getLocaleAgreement)
  if (payload && !error) {
    yield put(storeLocaleAgreement(payload))
  } else {
    yield call(handlingGetApiError, error)
  }
}
